var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00AB58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3697 24.3011V22.206L19.9308 12.4545H22.4805L17.0472 22.0213V22.1349H25.6836V24.3011H14.3697ZM21.3086 27V23.6832L21.3654 22.7244V17.9091H23.7873V27H21.3086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle4);
export default __webpack_public_path__ + "static/media/Circle-4.92b592e80662ca8c05f4058ecaefc5f9.svg";
export { ForwardRef as ReactComponent };